<template>
  <div class="wrapper">
    <van-swipe :autoplay="30000" class="banner-box" @change="onChange">
      <van-swipe-item class="banner-item">
        <img v-lazy="videoImg" style="width: 100%" v-show="!showVideo"/>
        <video
          v-show="showVideo"
          :src="videoUrl"
          class="video"
          ref="myVideo"
          controls="true"
        ></video>
        <img src="../image/scan/control.png" class="control" v-show="!showVideo" @click="playVideo"/>
      </van-swipe-item>
      <van-swipe-item v-for="(image, index) in images" :key="index">
        <img v-lazy="image" style="width: 100%" />
      </van-swipe-item>
    </van-swipe>
    <div class="company-box">
      <div v-html="context"></div>
    </div>
    <div></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Vue from "vue";
import { Swipe, SwipeItem, Lazyload } from "vant";
import "vant/lib/index.css";
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Lazyload);
export default {
  components: {},
  props: {},
  data() {
    return {
      current: 0,
      images: [],
      context: "",
      videoUrl: "",
      videoImg: "",
      showVideo:false,
    };
  },
  watch: {},
  computed: { ...mapState(["codeInfo"]) },
  methods: {
    onChange(index) {
      console.log(index);
      this.current = index;
    },
    playVideo(){
      if (!this.videoUrl) {
        this.$message({ message: "暂无视频资源！" });
        return false;
      }
      if (this.$refs.myVideo.paused) {
        this.$refs.myVideo.play();
        this.showVideo = true;
      } else {
        this.$refs.myVideo.pause();
      }
    },
  },
  created() {
    console.log(this.codeInfo);
    this.images = JSON.parse(
      this.codeInfo.companyInfo.companyInfoIntroduction.slideShow
    );
    this.context = this.codeInfo.companyInfo.companyInfoIntroduction.context;
    this.videoUrl = this.codeInfo.companyInfo.companyInfoIntroduction.videoUrl;
    this.videoImg = this.codeInfo.companyInfo.companyInfoIntroduction.fileUrl;
  },
  mounted() {
    console.log(this.codeInfo);
    (function (win, lib) {
      var doc = win.document;
      var docEl = doc.documentElement;
      var metaEl = doc.querySelector('meta[name="viewport"]');
      var flexibleEl = doc.querySelector('meta[name="flexible"]');
      var dpr = 0;
      var scale = 0;
      var tid;
      var flexible = lib.flexible || (lib.flexible = {});

      if (metaEl) {
        console.warn("将根据已有的meta标签来设置缩放比例");
        var match = metaEl
          .getAttribute("content")
          .match(/initial\-scale=([\d\.]+)/);
        if (match) {
          scale = parseFloat(match[1]);
          dpr = parseInt(1 / scale);
        }
      } else if (flexibleEl) {
        var content = flexibleEl.getAttribute("content");
        if (content) {
          var initialDpr = content.match(/initial\-dpr=([\d\.]+)/);
          var maximumDpr = content.match(/maximum\-dpr=([\d\.]+)/);
          if (initialDpr) {
            dpr = parseFloat(initialDpr[1]);
            scale = parseFloat((1 / dpr).toFixed(2));
          }
          if (maximumDpr) {
            dpr = parseFloat(maximumDpr[1]);
            scale = parseFloat((1 / dpr).toFixed(2));
          }
        }
      }

      if (!dpr && !scale) {
        var isAndroid = win.navigator.appVersion.match(/android/gi);
        var isIPhone = win.navigator.appVersion.match(/iphone/gi);
        var devicePixelRatio = win.devicePixelRatio;
        if (isIPhone) {
          // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
          if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
            dpr = 3;
          } else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)) {
            dpr = 2;
          } else {
            dpr = 1;
          }
        } else {
          // 其他设备下，仍旧使用1倍的方案
          dpr = 1;
        }
        scale = 1 / dpr;
      }

      docEl.setAttribute("data-dpr", dpr);
      if (!metaEl) {
        metaEl = doc.createElement("meta");
        metaEl.setAttribute("name", "viewport");
        metaEl.setAttribute(
          "content",
          "initial-scale=" +
            scale +
            ", maximum-scale=" +
            scale +
            ", minimum-scale=" +
            scale +
            ", user-scalable=no"
        );
        if (docEl.firstElementChild) {
          docEl.firstElementChild.appendChild(metaEl);
        } else {
          var wrap = doc.createElement("div");
          wrap.appendChild(metaEl);
          doc.write(wrap.innerHTML);
        }
      }

      function refreshRem() {
        var width = docEl.getBoundingClientRect().width;
        if (width / dpr > 540) {
          width = 540 * dpr;
        }
        var rem = width / 10;
        docEl.style.fontSize = rem + "px";
        flexible.rem = win.rem = rem;
      }

      win.addEventListener(
        "resize",
        function () {
          clearTimeout(tid);
          tid = setTimeout(refreshRem, 300);
        },
        false
      );
      win.addEventListener(
        "pageshow",
        function (e) {
          if (e.persisted) {
            clearTimeout(tid);
            tid = setTimeout(refreshRem, 300);
          }
        },
        false
      );

      if (doc.readyState === "complete") {
        doc.body.style.fontSize = 12 * dpr + "px";
      } else {
        doc.addEventListener(
          "DOMContentLoaded",
          function (e) {
            doc.body.style.fontSize = 12 * dpr + "px";
          },
          false
        );
      }
      refreshRem();
      flexible.dpr = win.dpr = dpr;
      flexible.refreshRem = refreshRem;
      flexible.rem2px = function (d) {
        var val = parseFloat(d) * this.rem;
        if (typeof d === "string" && d.match(/rem$/)) {
          val += "px";
        }
        return val;
      };
      flexible.px2rem = function (d) {
        var val = parseFloat(d) / this.rem;
        if (typeof d === "string" && d.match(/px$/)) {
          val += "rem";
        }
        return val;
      };
    })(window, window["lib"] || (window["lib"] = {}));
    if (
      this.codeInfo.marketingOuterVO &&
      this.codeInfo.marketingOuterVO.isMobile == "0"
    ) {
      this.codeInfo.loginForm = false; //不需要手机号直接领奖
    }
    function isIos() {
      //判断是IOS还是Android
      var userAgent = navigator.userAgent;
      var isAndroid =
        userAgent.indexOf("Android") > -1 || userAgent.indexOf("Adr") > -1; //android终端
      var isiOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        return false;
      } else if (isiOS) {
        return true;
      }
    }
    if (isIos()) {
      var isPageHide = false;
      window.addEventListener("pageshow", function () {
        if (isPageHide) {
          window.location.reload();
        }
      });
      window.addEventListener("pagehide", function () {
        isPageHide = true;
      });
    } else {
      var needRefresh = sessionStorage.getItem("need-refresh");
      if (needRefresh) {
        sessionStorage.removeItem("need-refresh");
        window.location.reload();
      }
    }
  },
};
</script>
<style lang="less" scoped>
@base: 40;

.wrapper {
  html {
    font-size: 20px;
  }
  background-color: #ffffff !important;
  position: relative;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  .banner-box {
    width: 100%;
    height: 40%;
    background-color: #000000;
    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
    .video {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
    .banner-item {
      position: relative;
      .control {
        width: 50px;
        height: 50px;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -25px;
        margin-top: -25px;
      }
    }
  }
  .company-box {
    width: 94%;
    margin: 0 auto;
    /deep/img {
      width: 106.38% !important;
      height: auto;
      margin-left: -3.19%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/scanCompanyInfo.vue